module.exports = __webpack_public_path__ + "img/Koala.68500486.png";